import confetti from 'canvas-confetti';

function playBeep(duration = 200, frequency = 880, volume = 0.1) {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = 'sine';
    o.frequency.value = frequency;
    o.connect(g);
    g.connect(ctx.destination);
    g.gain.value = volume;
    o.start();
    setTimeout(() => {
      o.stop();
      ctx.close();
    }, duration);
  } catch {}
}

function vibrate(ms = 100) {
  if (navigator.vibrate) navigator.vibrate(ms);
}

function fireConfetti(opts = {}) {
  const defaults = { particleCount: 80, spread: 70, origin: { y: 0.6 } };
  confetti({ ...defaults, ...opts });
}

export const feedbackService = {
  playBeep,
  vibrate,
  fireConfetti,
};
